import { addDoc, collection } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { db } from "../../../firebase";
import { COL_UPLOAD_ERRORS } from "../constants";

export async function persistUploadErrors(errors, maxPersist = 200) {
  const list = (errors || []).slice(0, maxPersist);
  const CHUNK = 50;
  for (let i = 0; i < list.length; i += CHUNK) {
    const slice = list.slice(i, i + CHUNK);
    await Promise.all(
      slice.map((err) =>
        addDoc(collection(db, COL_UPLOAD_ERRORS), {
          billNo: err.billNo ?? "",
          partNo: err.partNo ?? "",
          itemName: err.itemName ?? "",
          reason: err.reason ?? "",
          timestamp: err.timestamp || new Date().toISOString(),
        })
      )
    );
    await new Promise((r) => setTimeout(r, 0));
  }
}

export function downloadErrorsExcel(errors, fileName = "upload-errors.xlsx") {
  const rows = (errors || []).map((e) => ({
    BillNo: e.billNo ?? "",
    PartNo: e.partNo ?? "",
    ItemName: e.itemName ?? "",
    Reason: e.reason ?? "",
    Timestamp: e.timestamp ?? "",
  }));
  const ws = XLSX.utils.json_to_sheet(
    rows.length ? rows : [{ BillNo: "", PartNo: "", ItemName: "", Reason: "", Timestamp: "" }]
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Errors");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    fileName
  );
}

export function exportRecordsExcel(records, fileName = "sales-transactions-export.xlsx") {
  const rows = (records || []).map((r) => ({
    BillNo: r.billNo,
    TranDate: r.tranDate,
    CustomerName: r.customerName,
    EmployeeName: r.employeeName,
    NameStaffName: r.staffName,
    VoucherNo: r.voucherNo,
    "m Voucher No": r.mVoucherNo,
    ItemGroup: r.itemGroup,
    PartNo: r.partNo,
    ItemName: r.itemName,
    Alias: r.alias,
    ProductID: r.productId,
    Qty: r.qty,
    UnitPrice: r.unitPrice,
    Amount: r.amount,
    BranchID: r.branchId,
    UploadedAt: r.uploadedAt,
    UploadedBy: r.uploadedBy,
  }));
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sales");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    fileName
  );
}

export function downloadInvalidRowsExcel(rows, fileName = "invalid-sales-rows.xlsx") {
  const out = (rows || []).map((r) => ({
    RowNo: r._rowIndex ?? "",
    VoucherType: r.voucherType ?? "",
    VoucherNo: r.voucherNo ?? "",
    "m Voucher No": r.mVoucherNo ?? "",
    BillNo: r.billNo ?? "",
    TranDate: r.tranDate ?? "",
    CustomerName: r.customerName ?? "",
    EmployeeName: r.employeeName ?? "",
    NameStaffName: r.staffName ?? "",
    ItemGroup: r.itemGroup ?? "",
    Alias: r.alias ?? "",
    PartNo: r.partNo ?? "",
    ItemName: r.itemName ?? "",
    ProductID: r.productId ?? "",
    Qty: r.qty ?? "",
    UnitPrice: r.unitPrice ?? "",
    MRP: r.mrp ?? "",
    Discount: r.discount ?? "",
    DiscountAmt: r.discountAmt ?? "",
    Amount: r.amount ?? "",
    BillAmount: r.billAmount ?? "",
    ProfitCentre: r.profitCentre ?? r.profitPercent ?? "",
    profitpercent: r.profitPercent ?? r.profitCentre ?? "",
    WorkstationID: r.workstationId ?? "",
    BranchID: r.branchId ?? "",
    Errors: Array.isArray(r.errors) ? r.errors.join("; ") : String(r.errors || ""),
  }));
  const ws = XLSX.utils.json_to_sheet(out.length ? out : [{ RowNo: "", Errors: "" }]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "InvalidRows");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    fileName
  );
}
